import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { IconPlus } from "@tabler/icons-react";
import styles from "./Sections.module.scss";
/**
 * FAQ-аккордеон. Ответы ВСЕГДА в DOM (свёрнуты через grid-rows 0fr→1fr, а не
 * размонтированы) — иначе в пререндер-снимок для Яндекса попали бы только
 * вопросы, а JSON-LD FAQPage разошёлся бы с видимым текстом страницы.
 *
 * Снимок выглядит ровно как живая страница (открыт первый ответ): его отдают
 * всем посетителям, и раскрытый «для ботов» аккордеон схлопывался бы у них на
 * глазах в момент подмены статики приложением.
 */
export const Faq = ({ items }) => {
    const [open, setOpen] = React.useState(0);
    const baseId = React.useId();
    return (_jsx("div", { className: styles.faq, children: items.map((item, i) => {
            const isOpen = open === i;
            const panelId = `${baseId}-a${i}`;
            const buttonId = `${baseId}-q${i}`;
            return (_jsxs("div", { className: styles.faqItem, "data-open": isOpen, children: [_jsx("h3", { className: styles.faqH, children: _jsxs("button", { type: "button", className: styles.faqQ, id: buttonId, "aria-expanded": isOpen, "aria-controls": panelId, onClick: () => setOpen((cur) => (cur === i ? -1 : i)), children: [_jsx("span", { children: item.q }), _jsx("span", { className: styles.faqMark, "aria-hidden": "true", children: _jsx(IconPlus, { size: 18, stroke: 2 }) })] }) }), _jsx("div", { id: panelId, className: styles.faqPanel, role: "region", "aria-labelledby": buttonId, "aria-hidden": !isOpen, children: _jsx("div", { className: styles.faqPanelInner, children: _jsx("p", { children: item.a }) }) })] }, item.q));
        }) }));
};
